import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestData } from 'src/app/common/models/request-data.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeTypeService {

  private baseUrl = environment.baseUrl + '/' + environment.app + '/employee-type/';

  constructor(private http: HttpClient) { }

  getEmployeeTypeList(requestData: RequestData): Observable<any> {
    return this.http.post(this.baseUrl + 'get', requestData);
  }

  getEmployeeTypeById(id: any): Observable<any> {
    return this.http.post(this.baseUrl + 'get/' + id, '');
  }

  update(data: any): Observable<any> {
    return this.http.post(this.baseUrl + 'update', data);
  }
}
